import * as types from './types.js';

const INITIAL_STATE = {
  saveSuccessful: false,
  saveError: null,
  fetchError: null,
  saveLoading: false,
  fetchLoading: false,
  sites: [],
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.DEFAULT_LABOR_HOURS_FETCH_LOADING:
      return {
        ...state,
        fetchLoading: payload,
      };

    case types.DEFAULT_LABOR_HOURS_SAVE_LOADING:
      return {
        ...state,
        saveLoading: payload,
      };

    case types.DEFAULT_LABOR_HOURS_SAVE_SUCCESSFUL:
      return {
        ...state,
        saveSuccessful: payload,
      };

    case types.DEFAULT_LABOR_HOURS_GET_DEFAULT_LABOR_HOURS:
      return {
        ...state,
        sites: payload,
      };

    case types.DEFAULT_LABOR_HOURS_GET_DEFAULT_LABOR_HOURS_ERROR:
      return {
        ...state,
        fetchError: payload,
      };

    case types.DEFAULT_LABOR_HOURS_SAVE_DEFAULT_LABOR_HOURS_ERROR:
      return {
        ...state,
        saveError: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/defaultlaborhours/state/reducer.js